import React from 'react'

export type HeroProps = {
  bgImage: string,
  heading?: string,
  subHeading?: string,
};

const Hero: React.FC<HeroProps> = ({
  bgImage,
  heading,
  subHeading
}) => {
  return (
    <div className="w-full bg-main h-[200px] sm:h-[300px] lg:h-[400px] 2xl:h-[500px] hero bg-right bg-no-repeat bg-cover relative" style={{backgroundImage: `url(${bgImage})`}} >
      {(heading || subHeading) && (
        <div className="hero-text pl-6 lg:pl-10 xl:pl-0 max-w-5xl m-auto">
          {heading && (
            <h1 className="text-2xl md:text-5xl font-bold text-secondary font-volk capitalize">{heading.toLowerCase()}</h1>
          )}
          {subHeading && (
            <h3 className="text-xl md:text-3xl font-bold text-white font-volk">{subHeading}</h3>
          )}
        </div>
      )}
      <div className="w-full h-full hero-darken absolute top-0"></div>
    </div>
  );
}

export default Hero;